import React, { createContext, ReactNode, useContext } from 'react'
import { useFeatureFlags } from '@node-space/hooks'
import { Country } from 'types/types'

export interface CountriesContextData {
  countryOptions: Country[]
  isLoading: boolean
  isErrorLoading: boolean
}

export interface CountriesContextReturn extends CountriesContextData {
  filteredCountryOptions: Country[]
}

export interface CountriesContextProviderProps extends CountriesContextData {
  children: ReactNode
}

export const CountriesContext = createContext<CountriesContextReturn>({
  countryOptions: [],
  filteredCountryOptions: [],
  isLoading: false,
  isErrorLoading: false,
})

export const CountriesContextProvider = ({
  children,
  countryOptions,
  ...contextReturnValues
}: CountriesContextProviderProps) => {
  const { enableCountriesExclusionList, enableSignupUk } = useFeatureFlags()

  const filteredCountryOptions = countryOptions?.filter(({ value, label }) => {
    const showUk = enableSignupUk || value !== 'GB'
    const showExcludedCountry = !enableCountriesExclusionList?.some(
      excluded => excluded?.name === label || excluded.code === value
    )
    return showUk && showExcludedCountry
  })

  return (
    <CountriesContext.Provider
      value={{ ...contextReturnValues, countryOptions, filteredCountryOptions }}
    >
      {children}
    </CountriesContext.Provider>
  )
}

export const useCountriesContext = () => useContext(CountriesContext)
